
import Header from "../Home/Screens/Header"
import ContentFooter from "../Services/Screens/ContentFooter"



const ServicesModule = () => {




    return (
        <>
            <Header />
            <ContentFooter />
        </>
    )
}


export default ServicesModule